export default __webpack_public_path__ + "static/compareItemImg1-18ed482de240fcbf55d6d162cc2014d6.webp";